import { Colors, FontSizes } from '@unmind/design-system/theme/deprecated';
import React, { forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';
import Base, { Props as BaseTextProps } from './Base';

export interface Props extends Omit<BaseTextProps, 'sizes' | 'color'> {
  sizes?: FontSizes[];
  color?: Colors;
  /**
   * Not for manual use - this is used internally by Styled Components.
   * If you're trying to change the rendered type of this component, use `forwardedAs` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
}

const StyledBodyText = styled(Base)`
  line-height: 150%;
`;

const BodyText = forwardRef<HTMLElement, Props>(
  (
    {
      sizes = [
        FontSizes.fontSize16,
        FontSizes.fontSize16,
        FontSizes.fontSize20,
        FontSizes.fontSize22,
      ],
      color,
      className,
      children,
      as,
      ...props
    },
    ref,
  ) => {
    const { colors } = useTheme();

    return (
      <StyledBodyText
        sizes={sizes}
        color={color ?? colors.text.secondary}
        ref={ref}
        className={className}
        forwardedAs={as}
        {...props}
      >
        {children}
      </StyledBodyText>
    );
  },
);

export default BodyText;
